export enum ProductTypeEnum  {
  PRINT = 'print',
  TRANSPORT = 'transport',
  INSTALLATION = 'installation',
  SUBCONTRACTING = 'subcontracting',
  OTHER = 'other'
}
